<template>
  <div class="main-viewport">
    <!--<Head v-if="showHead" :title="$route.meta.title"></Head>-->
    <transition :name="hasKeep"  v-if="showTransition">
        <keep-alive :include="keepAlive">
          <router-view class="m-router"/>
        </keep-alive>
    </transition>
    <!--<keep-alive :include="keepAlive"  >-->
      <router-view class="m-router" v-if="!showTransition" />
    <!--</keep-alive>-->
    <Tabs v-if="showTab && sysCenter" :tabsItems="tabsItems"></Tabs>
    <Left-bar showLeft="true" showRight="true" menu="true" v-show="show"></Left-bar>
    <div  class="backBox" :class="{'showBack': showBackCode}" v-if="isMiniProgram"  @click="isGoBack()">
     <span class="back"> 返回 </span>
      <span class="icon icon-arrow-right" @click.stop="showBack()" v-if="!showBackCode"></span>
      <span class="icon icon-arrow-left" @click.stop="showBack()" v-if="showBackCode"></span>
    </div>
  </div>
</template>

<script>
import Tabs from '@/components/common/tabs/tabbar'
import Head from '@/components/common/header/head'
import LeftBar from '@/components/common/header/menuBar'
import { IsWechat } from '@/assets/scripts/wechat'
import { backArrows } from '@/components/common'
import { mapState } from 'vuex'
import Cookies from 'js-cookie'
export default {
  components: {
    Tabs, Head, LeftBar, backArrows
  },
  data () {
    return {
      showBackCode: false,
      isMiniProgram: false,
      showTransition: false,
      routerMeta: {},
      hasKeep: 'oed-left',
      tabsItems: [
        {
          icon: 'icon-center-outline',
          iconActive: 'icon-center'
        },
        {
          icon: 'icon-cart-outline',
          iconActive: 'icon-cart',
          title: '我的订单',
          path: '/order'
        },
        {
          icon: 'icon-mine-outline',
          iconActive: 'icon-mine',
          title: '个人中心',
          path: '/personage'
        }
      ]
    }
  },
  methods: {
    showBack () {
      this.showBackCode = !this.showBackCode
    },
    isGoBack () {
      if (this.showBackCode) { this.$router.go(-1) }
    }
  },
  computed: {
    //    isMiniProgram(){
    //
    //    },
    ...mapState({
      SID: state => state.sid
    }),
    show () {
      return this.$route.meta.menuBar
    },
    sysCenter () {
      let fristPage = {path: '/main', title: '首页'}
      fristPage = this.SID === '00-0' ? {path: '/main', title: '首页'} : {path: '/mec/' + this.SID, title: '中心主页'}
      Object.assign(this.tabsItems[0], fristPage)
      return fristPage
    },

    showTab () {
      return this.$route.meta.showTab
    },
    showHead () {
      return !this.$route.meta.hiddenHead && !IsWechat()
    },
    keepAlive () {
      return this.$store.state.keepAlive
    }
  },
  mounted () {
    //    if (IsWechat()) {
    //      window.addEventListener('pagehide',
    //        function () {
    //          Cookies.set('51jk._initSid', '')
    //          Cookies.set('51jk._sid', '')
    //        })
    //    } else {
    //      window.onbeforeunload = function () {
    //        Cookies.set('51jk._initSid', '')
    //        Cookies.set('51jk._sid', '')
    //      }
    //    }
  },
  created () {
    //    var ua = navigator.userAgent.toLowerCase();
    //   alert(IsWechat())
    if (IsWechat()) {
      window.wx.miniProgram.getEnv(res => { //获取当前环境
        //        alert(JSON.stringify(res))
        if (res.miniprogram) { // true 在微信小程序中
          //       alert('xcx')
          this.isMiniProgram = true
        } else { // false 在微信公众号里
          //          alert('gzh')
          this.isMiniProgram = false
          this.showTransition = true
        }
      })
    } else { //都不在
      this.isMiniProgram = false
      this.showTransition = true
    }
  },
  watch: {
    '$route' (to, from) { //  监听路由变化时的状态为前进还是后退
      if (to.name === 'order') {
        to.meta.showTab = !to.query.type
        to.meta.menuBar = !to.meta.showTab
      }
      let isBack = this.$router.isBack
      if (to.meta.grade && from.meta.grade) {
        if (to.meta.grade < from.meta.grade) {
          this.hasKeep = 'oed-right'
        } else {
          this.hasKeep = 'oed-left'
        }
      } else {
        if (isBack) {
          this.hasKeep = 'oed-right'
        } else {
          this.hasKeep = 'oed-left'
        }
        this.$router.isBack = false
      }
    }
  }
}

</script>
<style ref="stylesheet/scss" lang="scss">
  @import "@/assets/style/variables.scss";
.main-viewport {
  font-size: 14px;
  min-height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  -webkit-flex-direction: row;
  -webkit-align-content: stretch;
  align-content: stretch;
}

/*路由动画*/
.m-router {
  width: 100%;
  transition: all .5s ease;
}
.backBox{
  transition: left .5s ease;
  position: fixed;
  bottom: 150px;
  z-index: 10;
  background: $assertive ;
  color: $light;
  padding: 5px;
  left: -65px;
  border-radius: 0 15px 15px 0;
  .back{
    padding: 5px 15px 5px 15px;
  }
  .icon{
    padding: 0 10px;
  }
}
.showBack{
  left: 0;
}

.oed-left-enter, .oed-right-leave-active {
  position: absolute;
  opacity: 0;
  -webkit-transform: translate(100%, 0);
  transform: translate(100%, 0);
  .m-foot {
    opacity: 0;
  }
}

.oed-left-leave-active, .oed-right-enter {
  position: absolute;
  opacity: 0;
  -webkit-transform: translate(-100%, 0);
  transform: translate(-100% 0);
  .m-foot {
    opacity: 0;
  }
}
  .float-icon{
    position: fixed;
    bottom: 80px;
    right:20px;
  }
</style>
